﻿import { LocalStorageProperty } from "./Scripts/LocalStorageProperty";
import { scrollToFirstMatch } from "./Scripts/ScrollToFirstMatch";
import { PatternInputMask } from "./Scripts/PatternInputMask";
import { watchActivity } from "./Scripts/ActivityWatcher";


var culture = LocalStorageProperty('culture');
var jwt = LocalStorageProperty('jwt');
var username = LocalStorageProperty('username');
var forceLanguage = LocalStorageProperty('forceLanguage');
var fullName = LocalStorageProperty('fullName');
var logon = LocalStorageProperty('logon');
var passwordForceReset = LocalStorageProperty('passwordForceReset');
var passwordLoginTimeout = LocalStorageProperty('passwordLoginTimeout');
var partnerId = LocalStorageProperty('partnerId');
var partnerType = LocalStorageProperty('partnerType');
var permissions = LocalStorageProperty('permissions');
var userIsActive = LocalStorageProperty('userIsActive');
var userLocation = LocalStorageProperty('userLocation');
var partnerUserStoreId = LocalStorageProperty('partnerUserStoreId');

function createPatternMask(elementId, interopObject, pattern) {
    return new PatternInputMask(elementId, interopObject, pattern);
}

function createLocalStorageProperty(name) {
    return LocalStorageProperty(name);
}

export {
    culture,
    jwt,
    username,
    forceLanguage,
    fullName,
    logon,
    passwordForceReset,
    passwordLoginTimeout,
    partnerId,
    partnerType,
    permissions,
    userLocation,
    userIsActive,
    partnerUserStoreId,
    scrollToFirstMatch,
    createPatternMask,
    createLocalStorageProperty,
    watchActivity
}